import { render, staticRenderFns } from "./ModifyPhone.vue?vue&type=template&id=70a169ac&scoped=true"
import script from "./ModifyPhone.vue?vue&type=script&lang=js"
export * from "./ModifyPhone.vue?vue&type=script&lang=js"
import style0 from "./ModifyPhone.vue?vue&type=style&index=0&id=70a169ac&prod&lang=less&scoped=true"
import style1 from "./ModifyPhone.vue?vue&type=style&index=1&id=70a169ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a169ac",
  null
  
)

export default component.exports